import { Storage } from '../utils/storage.ts';
import type { TaskProvider } from './types';
import type { Project, Task } from '../types';

const KF_PROJECTS = 'kf-projects';
const KF_TASKS = 'kf-tasks';
const KF_CURRENT_TASK = 'kf-current-task';

const migrateKey = (oldKey: string, newKey: string): void => {
  if (!localStorage.getItem(newKey) && localStorage.getItem(oldKey)) {
    localStorage.setItem(newKey, localStorage.getItem(oldKey)!);
    localStorage.removeItem(oldKey);
  }
};

export const LocalProvider: TaskProvider = {
  loadProjects(): Project[] {
    migrateKey('kairofocus_projects', KF_PROJECTS);
    const raw = Storage.read<Project[]>(KF_PROJECTS, []);
    return raw.map((p, i) => ({
      sortOrder: i,
      createdAt: Date.now(),
      ...p,
    }));
  },

  saveProjects(projects: Project[]): void {
    Storage.write(KF_PROJECTS, projects);
  },

  loadTasks(): Task[] {
    migrateKey('kairofocus_tasks', KF_TASKS);
    const raw = Storage.read<Task[]>(KF_TASKS, []);
    return raw.map((t, i) => ({
      completed: false,
      sortOrder: i,
      createdAt: Date.now(),
      totalTimeSpent: 0,
      ...t,
    }));
  },

  saveTasks(tasks: Task[]): void {
    Storage.write(KF_TASKS, tasks);
  },

  loadCurrentTaskId(): string | null {
    migrateKey('kairofocus_current_task', KF_CURRENT_TASK);
    return Storage.read<string | null>(KF_CURRENT_TASK, null);
  },

  saveCurrentTaskId(id: string | null): void {
    Storage.write(KF_CURRENT_TASK, id);
  },
};
